import { ajax } from "@/plugins/ajax";

export default {
  namespaced: true,
  state: {
    list: [],
    details: []
  },
  getters: {
    list: state => state.list,
    details: state => state.details
  },
  actions: {
    fetch({ commit, dispatch }) {
      return ajax.get("IdentityAccess/api/RolesQuery").then(r => {
        commit("setList", r.data.data);
      });
    },
    fetchByRoleId({ commit }, id) {
      return new Promise((resolve, reject) => {
        ajax
          .get("IdentityAccess/api/RolesQuery/0/" + id)
          .then(r => {
            commit("setDetails", r.data);
            resolve(r.data);
          })
          .catch(e => reject(e));
      });
    },
    create({ commit, dispatch }, model) {
      return ajax.post("IdentityAccess/api/Roles", model).then(() => {});
    },
    remove({ commit, dispatch }, id) {
      return ajax
        .delete(
          "IdentityAccess/api/Roles",
          { data: { id: id } },
          { headers: { "Content-Type": "application/json" } }
        )
        .then(() => {});
    },
    update({ commit, dispatch }, model) {
      return ajax.put("IdentityAccess/api/Roles", model).then(() => {});
    },
    updateRolePermissions({ commit, dispatch }, model) {
      return ajax
        .post("IdentityAccess/api/RolePermissions", model)
        .then(() => {});
    }
  },
  mutations: {
    setList(state, data) {
      state.list = data;
    },
    setDetails(state, data) {
      state.details = data;
    }
  }
};
